import React, { useState, createContext } from 'react';

export const PageContext = createContext();
export const PageDispatcherContext = createContext();

function PageProvider({ children }) {
  const [state, setState] = useState({ page: 0, action: 'PUSh', pageSize: 10 });

  return (
    <PageContext.Provider value={state}>
      <PageDispatcherContext.Provider value={setState}>{children}</PageDispatcherContext.Provider>
    </PageContext.Provider>
  );
}

export { PageProvider };
